import styled from 'styled-components';
import { TelehealthActionsVariations } from '../../../search/ResultView/ResultList/TelehealthActions/TelehealthActions';
import { ThemeColours } from '../../styles/ThemeColours';
import { propSwitch } from '../../util/propSwitch';

export const HorizontalScrollBoxWrapper = styled.div<{
  variation: TelehealthActionsVariations;
}>`
  display: flex;
  flex-direction: ${({ variation }) => (variation === 'vertical' ? 'column' : 'row')};
  overflow-x: scroll;
  // Padding required for horizontal scroll bar
  padding-bottom: 12px;
`;

const SCROLL_OVERFLOW_WIDTH = '30px';

export const HorizontalScrollBoxContainer = styled.div<{
  overflowRight: boolean;
  overflowLeft: boolean;
}>`
  position: relative;
  &:before,
  &:after {
    content: '';
    position: absolute;
    display: inline-block;
    height: 100%;
    width: ${SCROLL_OVERFLOW_WIDTH};
    z-index: 1;
    top: 0;
    width: 0;
    transition: width 0.3s;
    opacity: 0.7;
  }

  &:before {
    background-image: radial-gradient(
      ellipse farthest-side at 0 center,
      ${ThemeColours.primary600} 0%,
      transparent 100%
    );
    left: 0;
    width: ${propSwitch('overflowLeft', SCROLL_OVERFLOW_WIDTH, 0)};
  }

  &:after {
    background-image: radial-gradient(
      ellipse farthest-side at 100% center,
      ${ThemeColours.primary600} 0%,
      transparent 100%
    );
    right: 0;
    width: ${propSwitch('overflowRight', SCROLL_OVERFLOW_WIDTH, 0)};
  }
`;
